var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgJustLogoIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44.327,
    height: 47.473,
    viewBox: "0 0 44.327 47.473",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1876",
    "data-name": "Group 1876",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M684.813-831.739c-14.352,0-19.568-1.367-19.784-1.425l-2.38-.644.636-2.382c7-26.235,19.153-40.312,19.667-40.9l1.861-2.123,1.861,2.123c.514.586,12.67,14.663,19.668,40.9l.635,2.382-2.38.644C704.381-833.106,699.165-831.739,684.813-831.739Zm-16.022-5.779a122.843,122.843,0,0,0,16.022.83,122.939,122.939,0,0,0,16.022-.83c-5.107-17.646-12.581-29.21-16.023-33.917a85.472,85.472,0,0,0-4.914,7.576A118.759,118.759,0,0,0,668.791-837.518Zm17.883-36.308Z",
    transform: "translate(-662.649 879.211)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJustLogoIcon);
export default __webpack_public_path__ + "static/media/just-logo-icon.f7da417c4e0516d06d80ffb8c416bc29.svg";
export { ForwardRef as ReactComponent };